import React from "react";
import { Globe, MapPin, Phone, Mail } from "lucide-react";
import "./footer.css";

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-info">
            <div className="footer-logo">
              <img
                src="/images/footerlogo.png"
                alt="Lothal International Logo"
                className="logo-icon"
                // width="75"
                // height="75"
              />
            </div>
            <p>
              Delivering logistics excellence with speed, trust, and global
              reach. Simplifying international trade for businesses worldwide.
            </p>
            <div className="social-links">
              <a href="#" className="social-btn">
                in
              </a>
              <a href="#" className="social-btn">
                f
              </a>
              <a href="#" className="social-btn">
                ig
              </a>
              <a href="#" className="social-btn">
                wa
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <div className="footer-links">
              <a href="#home">Home</a>
              <a href="#about">About Us</a>
              <a href="#services">Services</a>
              <a href="#tracking">Tracking</a>
              <a href="#contact">Contact Us</a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <div className="footer-links">
              <a href="#services">Air Freight</a>
              <a href="#services">Sea Freight</a>
              <a href="#services">Customs Clearance</a>
              <a href="#services">Warehousing</a>
              <a href="#services">Road Transport</a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={20} />
                <span>Ahmedabad, Gujarat, India</span>
              </div>
              <div className="contact-item">
                <Phone size={20} />
                <span>+91 XXXXX XXXXX</span>
              </div>
              <div className="contact-item">
                <Mail size={20} />
                <span>info@lothalinternational.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Lothal International. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
